import { Equipamento, Pessoa } from '@tivic-team/manager-ts/dist/grl';
import { Agente, AitTransporte, InfracaoTransporte, Talonario } from '@tivic-team/manager-ts/dist/mob';
import { ConcessaoVeiculo } from '@tivic-team/manager-ts/dist/mob/entities/concessao/concessao-veiculo.entity';
import { Linha } from '@tivic-team/manager-ts/dist/mob/entities/linha/linha.entity';
import { Usuario } from '@tivic-team/manager-ts/dist/seg';

export class AitTransporteDTO extends AitTransporte{

    infracaoTransporte: InfracaoTransporte = void(0);
	equipamento: Equipamento = void(0);
	usuario: Usuario = void(0);
	agente: Agente = void(0);
    concessionario:Pessoa = void(0);
    concessaoVeiculo:ConcessaoVeiculo = void(0);
	talonario: Talonario = void(0);
    linha: Linha = void(0);

    constructor(
        infracaoTransporte?:InfracaoTransporte,
        equipamento?:Equipamento,
        usuario?:Usuario,
        agente?:Agente,
        concessionario?:Pessoa,
        concessaoVeiculo?:ConcessaoVeiculo,
        talonario?:Talonario,
        linha?: Linha){
        super();
        this.infracaoTransporte = infracaoTransporte;
        this.equipamento = equipamento;
        this.usuario = usuario;
        this.agente = agente;
        this.concessionario = concessionario;
        this.concessaoVeiculo = concessaoVeiculo;
        this.talonario = talonario;
        this.linha = linha;
    }
}

export class AitTransporteListDTO {
    items: Array<AitTransporteDTO>;
    total: number;
    constructor() {}
}